import api from '@pray/shared/utils/api';
import type { FieldMappings } from './types';
type Props = {
  artistId: string; catalogId: string;
  url: string; headers: Record<string, string>; refreshCron: string; timeoutMs: number; responseMapping: FieldMappings;
};
export async function putSource({ artistId, catalogId, url, headers, refreshCron, timeoutMs, responseMapping }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  // Backend Zod expects `response_mapping` (fieldName → JSONPath); it returns { source },
  // not a catalog, so callers don't map the result — they refetch the catalog instead.
  await api.executePutRequest(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/source`,
    { url, http_method: 'GET', headers, refresh_cron: refreshCron, timeout_ms: timeoutMs, response_mapping: responseMapping });
}
